// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
  /* tslint:disable */
  export const VERSION = {
    "version": "8.3.28"
};
  /* tslint:enable */
  